import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { COMPARISON_CLOSING, COMPARISON_TITLE, COMPARISON_WITH, COMPARISON_WITHOUT, comparisonRows } from '../data/halloweenKit';
export function ComparisonSection() {
  return <section className="w-full bg-night-900 py-14 sm:py-20" aria-labelledby="comparison-title" data-id="element-50" data-mp="39d6chhh0lz9l">
      <div className="mx-auto max-w-3xl px-5" data-id="element-51" data-mp="34f4uz0z8m808">
        <h2 id="comparison-title" className="text-center font-display text-[1.75rem] font-semibold leading-tight text-cream-50 sm:text-[2.5rem]" data-id="element-52" data-mp="2zgbk7gbc4v3r">
          {COMPARISON_TITLE}
        </h2>

        <div className="mt-9 grid grid-cols-2 gap-x-4 border-b border-night-600 pb-3 text-[11px] font-bold uppercase tracking-[0.16em] sm:gap-x-8" data-id="element-53" data-mp="2qf3lwy8tju9o">
          <span className="text-muted" data-id="element-54" data-mp="2liwq3ya4zz5g">{COMPARISON_WITHOUT}</span>
          <span className="text-pumpkin" data-id="element-55" data-mp="on7arpqkcmff">{COMPARISON_WITH}</span>
        </div>

        <ul className="divide-y divide-night-600 border-b border-night-600" data-id="element-56" data-mp="jp5rp4t50n3y">
          {comparisonRows.map(row => <li key={row.without} className="grid grid-cols-2 items-start gap-x-4 py-4 sm:gap-x-8" data-id="element-57" data-mp="3aebfa2h7i8by">
              <p className="flex items-start gap-2 text-[14px] leading-snug text-body sm:text-[15px]" data-id="element-58" data-mp="3ehhguwtdjbc3">
                <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-pumpkin-dark" strokeWidth={3} aria-hidden="true" data-id="element-59" data-mp="30ihtdshll2hi" />
                {row.without}
              </p>
              <p className="flex items-start gap-2 text-[14px] font-medium leading-snug text-cream-50 sm:text-[15px]" data-id="element-60" data-mp="3t52maxdq1mn6">
                <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-pumpkin" strokeWidth={3} aria-hidden="true" data-id="element-61" data-mp="1y9kpsf0nli4" />
                {row.with}
              </p>
            </li>)}
        </ul>

        <p className="mx-auto mt-9 max-w-xl text-center font-display text-xl leading-snug text-cream-50 sm:text-2xl" data-id="element-62" data-mp="3odkv311i30fe">
          {COMPARISON_CLOSING[0]}
          <span className="mt-1 block italic text-pumpkin-light" data-id="element-63" data-mp="kpsnpz91izk5">{COMPARISON_CLOSING[1]}</span>
        </p>
      </div>
    </section>;
}